export default __webpack_public_path__ + "static/media/lantern.c5fcff93.svg";